import type { MultilinkStoryblok } from '@/types/storyblok-types';

export const sanitizeUrl = (url) => {
  // Used here because all our pages are in the sub-folder "pages" inside the Storyblok Admin panel.
  return url.replace('pages', '').replace('//', '/');
};

export const storyblokLink = (link: MultilinkStoryblok): string => {
  let url = link?.url || '';
  if (link?.linktype === 'url') return link.url;

  if (link?.linktype === 'story') {
    if (link.story) {
      url = link.story?.full_slug;
    } else {
      url = link.cached_url;
    }
  }
  if (link.path && link.path !== '') url = link.path;

  if (!url || url === 'home' || url === 'pages/home') return '/';

  return sanitizeUrl(url);
};
